/**
 * Listas cerradas de presentación y vía de administración.
 *
 * Viven aparte del formulario porque las usan tanto la fila de medicamento como
 * el PDF de la fórmula, y porque una lista cerrada evita que la misma vía se
 * escriba de cinco maneras distintas y la droguería tenga que interpretarla.
 */

export const PRESENTATIONS = [
  'Tableta', 'Tableta recubierta', 'Cápsula', 'Jarabe', 'Suspensión',
  'Ampolla', 'Vial', 'Crema', 'Ungüento', 'Gotas', 'Parche',
  'Inhalador', 'Supositorio', 'Óvulo', 'Sobre',
];

export const ROUTES = [
  'Oral', 'Sublingual', 'Tópica', 'Intramuscular', 'Intravenosa',
  'Subcutánea', 'Oftálmica', 'Ótica', 'Nasal', 'Rectal', 'Vaginal', 'Inhalatoria',
];
